import { render, staticRenderFns } from "./playerTalentSendAudit.vue?vue&type=template&id=6cebcdfc&scoped=true&"
import script from "./playerTalentSendAudit.vue?vue&type=script&lang=js&"
export * from "./playerTalentSendAudit.vue?vue&type=script&lang=js&"
import style0 from "./playerTalentSendAudit.vue?vue&type=style&index=0&id=6cebcdfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cebcdfc",
  null
  
)

export default component.exports